import { useForm, Controller, SubmitHandler } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";
import { useState, useEffect } from "react";
import {
  sCmpUserReportService,
  sCmpUserReportDownloadService,
} from "../../services/sCmpUserReportService";
import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import {
  GET_CMP_USER_REPORT_FAILURE,
  GET_CMP_USER_REPORT_SUCCESS,
} from "../../container/SCmpUserReport/types";
import { toast } from "react-toastify";
type FormInputs = {
  name: string;
  date: Date;
  fromDate1: any;
  ToDate1: any;
  id: string;
};
type TReportProps = {
  companyId: string;
};
const ExpenseReport = ({ companyId }: TReportProps) => {
  const [state, dispatch]: any = useStore();
  const [date, setDate] = useState<any>({
    fromDate: new Date(),
    toDate: new Date(),
  });
  const { handleSubmit } = useForm<FormInputs>();
  useEffect(() => {
    var today = new Date();
    var day = String(today.getDate()).padStart(2, "0");
    var month = String(today.getMonth() + 1).padStart(2, "0");
    var year = today.getFullYear();

    var nextMonth = month === "01" ? "01" : `0${parseInt(month) - 1}`;

    const fromDate = new Date(year + "-" + nextMonth + "-" + day);
    const toDate = new Date(year + "-" + month + "-" + day);
    setDate({ fromDate, toDate });
  }, []);

  const onSubmit: SubmitHandler<FormInputs> = async () => {
    const fromDateEng = date.fromDate.toISOString().slice(0, 10);
    const toDateEng = date.toDate.toISOString().slice(0, 10);
    sCmpUserReportDownloadService(fromDateEng, toDateEng, companyId);
  };
  const handleUserReport = () => {
    const fromDateEng = date.fromDate.toISOString().slice(0, 10);
    const toDateEng = date.toDate.toISOString().slice(0, 10);
    sCmpUserReportService(fromDateEng, toDateEng, companyId)
      .then((res: any) => {
        dispatch({ type: GET_CMP_USER_REPORT_SUCCESS, SCmpUserReport: res });
      })
      .catch((err) => {
        dispatch({
          type: GET_CMP_USER_REPORT_FAILURE,
          SCmpUserReportError: err,
        });
        toast.error("Select company");
      });
  };

  return (
    <InputDiv>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="w-80 bg-white pt-4 text-center rounded d-flex"
        style={{
          // width: "68.5%",
          display: "flex",
          justifyItems: "flex-start",
          // flexDirection: "row",
          // justifyContent: "space-between",
        }}
      >
        <br />

        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 22px",
            fontWeight: "500",
          }}
        >
          English Start Date
        </label>
        <DatePicker
          onChange={(e: any) => setDate({ ...date, fromDate: e })}
          selected={date.fromDate}
          placeholderText="Enter Date"
          className="calender"
        />
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "34px",
            marginRight: "48px",
            fontWeight: "500",
          }}
        >
          English End Date
        </label>
        <DatePicker
          onChange={(e: any) => setDate({ ...date, toDate: e })}
          selected={date.toDate}
          placeholderText="Enter Date"
          className="calender"
        />
        <button className="searchBtn"> Download</button>
        <button className="searchBtn" type="button" onClick={handleUserReport}>
          {" "}
          View
        </button>
      </form>
    </InputDiv>
  );
};

export default ExpenseReport;
